import { useState } from 'react';
import Header from '../../../../components/layout/Header';
import HeroWithBento from './HeroWithBento';
import OnboardingPanel from './panels/OnboardingPanel';
import StrategyPanel from './panels/StrategyPanel';
import CalendarPanel from './panels/CalendarPanel';
import ResultsPanel from './panels/ResultsPanel';

const AiMarketing = () => {
  const [activePanel, setActivePanel] = useState(null);

  const handlePanelOpen = (panelId) => {
    setActivePanel(panelId);
  };

  const handlePanelClose = () => {
    setActivePanel(null);
  };

  return (
    <div className="min-h-screen" style={{ background: '#060e1e' }}>
      <Header />

      {/* Hero Section with Interactive Bento Grid */}
      <HeroWithBento onPanelOpen={handlePanelOpen} />

      {/* Interactive Panels */}
      {activePanel === 'onboarding' && <OnboardingPanel onClose={handlePanelClose} />}
      {activePanel === 'strategy' && <StrategyPanel onClose={handlePanelClose} />}
      {activePanel === 'calendar' && <CalendarPanel onClose={handlePanelClose} />}
      {activePanel === 'results' && <ResultsPanel onClose={handlePanelClose} />}
    </div>
  );
};

export default AiMarketing;